import { breakpoints } from '../../theme/theme';

const getDecimalInt = (breakpoint: string) => parseInt(breakpoint, 10);

const getBreakpointEdge = (breakpoint: string) => `${getDecimalInt(breakpoint) - 1}px`;

export const getMediaWidthMin = (index: number) => `(min-width: ${breakpoints[index]})`;

export const getMediaWidthMax = (index: number) =>
  `(max-width: ${getBreakpointEdge(breakpoints[index])})`;

export const getMediaWidthMinMax = (index: number) =>
  `${getMediaWidthMin(index - 1)} and ${getMediaWidthMax(index)}`;
